import React from "react";
import { motion } from "framer-motion";
import { Sun, Moon } from "lucide-react";

export default function ThemeToggle({ theme, onToggle, overHero = false }) {
  const isDark = theme === "dark";
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-label="Toggle color theme"
      data-testid="theme-toggle"
      className={`relative h-9 w-[68px] rounded-full transition-colors duration-300 flex items-center px-1.5 ${
        overHero
          ? "border border-white/25 bg-white/10 hover:bg-white/20 hover:border-white/40"
          : "border border-line/15 bg-line/5 hover:border-line/30 hover:bg-line/10"
      }`}
    >
      <motion.span
        animate={{ x: isDark ? 32 : 0 }}
        transition={{ type: "spring", stiffness: 380, damping: 30 }}
        className={`absolute top-1.5 left-1.5 h-6 w-6 rounded-full shadow-sm grid place-items-center ${
          overHero ? "bg-white" : "bg-ink"
        }`}
      >
        {isDark ? (
          <Moon
            className={`w-3.5 h-3.5 ${overHero ? "text-black" : "text-surface"}`}
            strokeWidth={1.6}
          />
        ) : (
          <Sun
            className={`w-3.5 h-3.5 ${overHero ? "text-black" : "text-surface"}`}
            strokeWidth={1.6}
          />
        )}
      </motion.span>
      <span className="flex w-full justify-between px-1.5 pointer-events-none">
        <Sun
          className={`w-3.5 h-3.5 transition-opacity duration-300 ${
            isDark
              ? overHero
                ? "opacity-50 text-white"
                : "opacity-30 text-ink-2"
              : "opacity-0"
          }`}
          strokeWidth={1.4}
        />
        <Moon
          className={`w-3.5 h-3.5 transition-opacity duration-300 ${
            !isDark
              ? overHero
                ? "opacity-50 text-white"
                : "opacity-30 text-ink-2"
              : "opacity-0"
          }`}
          strokeWidth={1.4}
        />
      </span>
    </button>
  );
}
